
import { PrivacyPolicySection } from '../components/privacy-policy';

function PrivacyPolicy() {
  return (
    <PrivacyPolicySection />
  );
}

export default PrivacyPolicy;